var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.graphOptions
    ? _c(
        "div",
        { staticClass: "pres-2026-col-graph" },
        [
          _c("v-chart", {
            ref: "elec2026graph",
            attrs: { autoresize: true, option: _vm.graphOptions },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }